import { postRequest, getRequest, putRequest, putFormdata, deleteRequest } from "../axios";
/**
 * Api call
 */
class authService {

    login = async (payload) => {
        return await postRequest('executive/login', payload);
    }
    forgotPassword = async (payload) => {
        return await postRequest('executive/forgot-password', payload);
    }
    newPassword = async (payload) => {
        return await postRequest('executive/new-password', payload);
    }
    updatePassword = async (payload) => {
        return await putRequest('executive/update-password', payload);
    }
    logout = async () => {
        return await postRequest('executive/logout');
    }


    updateTaxfileStatus = async (payload) => {
        return await putRequest('executive/taxfile/status', payload);
    }
    getTaxfileStatus = async (payload) => {
        return await getRequest('executive/taxfile/status', payload);
    }



    // addExecutiveMessage = async (payload) => {
    //     return await postRequest('executive/taxfile/chat', payload);
    // }
    // getExecutiveMessages = async (id) => {
    //     return await getRequest(`executive/taxfile/chat/${id}`);
    // }

    addExecutiveMsg = async (payload) => {
        return await postRequest('executive/message', payload);
    }
    getExecutiveMsg = async (id) => {
        return await getRequest(`executive/message/${id}`);
    }
    userMsgListCount = async (payload) => {
        return await getRequest('executive/message', payload);
    }
    dashUserMsgListCount = async (payload) => {
        return await getRequest('executive/message?unread=true', payload);
    }



    taxfilesList = async ({queryParams}) => {
        return await getRequest(`executive/taxfile`,queryParams);
    }
    taxfileDetail = async (id) => {
        return await getRequest(`executive/taxfile/${id}`);
    }
    taxfilesListWithCount = async (payload) => {
        return await getRequest('executive/taxfile-message-count', payload);
    }
    updateTaxfile = async (payload) => {
        return await putFormdata('executive/taxfile', payload);
    }






    addExecutive = async (payload) => {
        return await postRequest('executive/add', payload);
    }
    executivesList = async (payload) => {
        return await getRequest('executive/list', payload);
    }
    updateExecutiveStatus = async (payload) => {
        return await putRequest('executive/status', payload);
    }



    addTemplate = async (payload) => {
        return await postRequest('executive/template', payload);
    }
    templatesList = async (payload) => {
        return await getRequest('executive/template', payload);
    }




    getMaritalStatus = async (id = null) => {
        return await getRequest(`user/marital-status`);
    }
    getProvinces = async (id = null) => {
        return await getRequest(`user/provinces`, id);
    }
    getDocumentTypes = async ({type = ''}) => {
        return await getRequest(`user/document-types?type=${type}`);
    }
  
    createPayentRequest = async (payload) => {
        return await postRequest('executive/payment/create-request', payload);
    }

    createNrcPaymentRequest = async (payload) => {
        return await postRequest('executive/payment/create-nrc-request', payload);
    }

    getNrcPaymentRequests = async () => {
        return await getRequest(`executive/payment/nrc-request`);
    }
  
    verifyPaymentOrder = async (id,payload) => {
        return await postRequest(`executive/payment/verify-order/${id}`, payload);
    }

    refreshPaymentOrderStatus = async (id) => {
        return await postRequest(`executive/payment/refresh-order-status/${id}`);
    }

    taxfileAddComment = async (id,payload) => {
        return await postRequest(`executive/taxfile/${id}/add-comment`,payload);
    }

    taxfileDeleteComment = async (id,payload) => {
        return await deleteRequest(`executive/taxfile/comment/${id}`,payload);
    }




}

const instance = new authService();

export default instance;